import React from 'react';
import { Cross2Icon } from '@radix-ui/react-icons';
import { UnstyledButton } from './UnstyledButton';
import { cn } from '@/shared/ui/utils/tailwind';

export type DismissIconButtonProps = {
  /** Accessible name and native tooltip for the dismiss action. */
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
};

/**
 * Icon-only dismiss control (X). Transparent by design — never uses the solid
 * primary Button fill, which clips/hides the icon inside a red square.
 */
export function DismissIconButton({
  label,
  onClick,
  disabled = false,
  className,
}: DismissIconButtonProps): React.ReactElement {
  return (
    <UnstyledButton
      type="button"
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'inline-flex items-center justify-center size-8 shrink-0',
        'rounded-(--radius-md) border-none bg-transparent cursor-pointer p-0',
        'text-(--text-tertiary) hover:text-(--status-error) hover:bg-(--surface-hover)',
        'transition-all duration-(--duration-fast) disabled:opacity-50 disabled:pointer-events-none',
        className,
      )}
    >
      <Cross2Icon width={14} height={14} aria-hidden />
    </UnstyledButton>
  );
}
